import FieldConfiguration from '@/Models/FieldConfiguration';
import FieldCategory from '@/Models/FieldCategory';
import Store from '@/Models/Store';
import _ from 'lodash';

class StoreManager {
    /**
     * @var {FieldCategory[]} categories
     */
    categories;

    /**
     * @var {FieldConfiguration[]} fields
     */
    fields;
    #rows;

    /**
     * @var {Store[]} stores
     */
    stores;

    constructor(attributes) {
        this.stores = attributes.stores.map(store => new Store(store));

        this.categories = attributes.categories.map(category => {
            category.fields = category.fields.map(
                field => new FieldConfiguration(field));
            return new FieldCategory(category);
        });

        this.fields = attributes.fields.map(
            field => new FieldConfiguration(field));

        this.#rows = [
            this.getFieldByNumber(1),
            ...this.categories,
            this.getFieldByNumber(600),
        ];
    }

    /**
     * @param {string} id
     * @return {Store|null}
     */
    getStore(id) {
        if (!id) {
            return null;
        }

        return this.stores.find(store => store.id === id);
    }

    /**
     * @return {Store[]}
     */
    getStores() {
        return this.stores;
    }

    get rows() {
        return _.cloneDeep(this.#rows);
    }

    /**
     * @param {string} key
     * @param {Store} store
     * @return {FieldConfiguration}
     */
    getField(key, store = null) {
        let field = this.fields.find(field => {
            return field.key === key;
        });

        return this.#resolveFieldOverrides(field, store);
    }

    /**
     * @param {Store} store
     * @return {FieldConfiguration[]}
     */
    getFields(store = null) {
        return this.fields.map(
            field => this.#resolveFieldOverrides(field, store)
        );
    }

    /**
     * @param {number} number
     * @param {Store} store
     * @return {FieldConfiguration}
     */
    getFieldByNumber(number, store = null) {
        let field = this.fields.find(field => field.number === number);

        return this.#resolveFieldOverrides(field, store);
    }

    /**
     * @param {FieldConfiguration} field
     * @param {Store} store
     * @return {FieldConfiguration}
     */
    #resolveFieldOverrides(field = null, store = null) {
        if (!store || !field) {
            return field;
        }

        let relation = field.stores.find(relation => store.id === relation.id);

        if (!relation) {
            return field;
        }

        let override = relation.override;

        field.calculated_by = override.calculated_by ?? field.calculated_by;

        if (field.calculated_by === CalculatedBy.FORMULA) {
            field.formula = override.formula ?? field.formula;
        } else {
            field.formula = null;
        }

        return field;
    }
}

export default StoreManager;
